export default "__VITE_ASSET__Cvuc_m8S__"